export const EMPTY_MOVE = {
  color: "",
  flags: "",
  piece: "",
  san: "",
  from: "",
  to: "",
};
